import { IPrice } from "sagas/priceSaga";

export enum PriceActionTypes {
  FETCH_PRICE_REQUEST = "FETCH_PRICE_REQUEST",
  FETCH_PRICE_SUCCESS = "FETCH_PRICE_SUCCESS",
  FETCH_PRICE_FAILURE = "FETCH_PRICE_FAILURE",
}

// Action interfaces
export interface FetchPriceRequestAction {
  type: PriceActionTypes.FETCH_PRICE_REQUEST;
}

export interface FetchPriceSuccessAction {
  type: PriceActionTypes.FETCH_PRICE_SUCCESS;
  payload: IPrice;
}

export interface FetchPriceFailureAction {
  type: PriceActionTypes.FETCH_PRICE_FAILURE;
  payload: string;
}

// Action creators
export const fetchPriceRequest = (): FetchPriceRequestAction => ({
  type: PriceActionTypes.FETCH_PRICE_REQUEST,
});

export const fetchPriceSuccess = (data: IPrice): FetchPriceSuccessAction => ({
  type: PriceActionTypes.FETCH_PRICE_SUCCESS,
  payload: data,
});

export const fetchPriceFailure = (error: string): FetchPriceFailureAction => ({
  type: PriceActionTypes.FETCH_PRICE_FAILURE,
  payload: error,
});

export type PriceActions =
  | FetchPriceRequestAction
  | FetchPriceSuccessAction
  | FetchPriceFailureAction;
